import React from "react";
import styles from "./TextArea.module.scss";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";
import { Input } from "../Input/Input";
import { InputControlProps, WithLabelAndErrorComponent } from "@/types/formControls";

const TextArea: React.FC<InputControlProps> = ({ className, ...props }) => {
  return (
    <Input
      minRows={2}
      maxRows={4}
      {...props}
      multiline
      className={combineClasses(styles.inputRoot, className)}
    />
  );
};

const TextAreaWithLabelAndError = withLabelAndError(TextArea as WithLabelAndErrorComponent);

export default TextAreaWithLabelAndError;
export { TextArea };
